<app-three-column-template [hasBreadcrumb]="true"
                           [hasCustomMain]="true"
                           [showTags]="false"
                           [pageData]="pageData()">

  <app-side-navigation [pageData]="pageData()" slot="left-section"></app-side-navigation>
  <app-breadcrumbs [pageData]="pageData()"
                   slot="breadcrumb-section"></app-breadcrumbs>


  @if (pageData().showContents) {
    <app-toc></app-toc>
  }
  <app-ck-viewer [htmlDescription]="pageData()?.summary"></app-ck-viewer>
  <app-ck-viewer
    [fullBody]="true"
    [htmlDescription]="pageData()?.htmlDescription"></app-ck-viewer>


  <div class="news-description">
    @if (pageData() && pageData().document) {
      <div class="preview">
        <img [alt]="pageData().title" [src]="imageUrl()" width="300">
        <div></div>
        <a [download]="pageData().document.fileName" [href]="pageData().document.sourceUrl" target="_blank">
          <span class="button">{{ 'Download' |translate }}</span>
        </a>
      </div>
    }
  </div>

  <app-related-items [pageData]="pageData()"></app-related-items>

  <ng-container slot="right-section">
    <app-links-section
      [isQuickLinks]="true"
      [links]="pageData()?.quickUrls"
      [title]="'Quick links'"></app-links-section>

    <app-default-portlets [pageData]="pageData()"></app-default-portlets>


  </ng-container>
</app-three-column-template>
